import { Routes, Route, Navigate } from "react-router-dom";
import Navigation from "../../../components/Navigation/Navigation.js";
import Individual from "./Personal/Personal.js";
import National from "./National/National.js";

const Overall = () => {
  const tabs = [
    { path: "personal", label: "Individual" },
    { path: "national", label: "Country" },
  ];

  return (
    <>
      <Navigation tabs={tabs} basePath="/game-summary/overall" variant="tab" />

      <Routes>
        <Route path="/" element={<Navigate to="personal" replace />} />
        <Route path="personal/" element={<Individual />} />
        <Route path="national/" element={<National />} />
      </Routes>
    </>
  );
};
export default Overall;
